import { render, staticRenderFns } from "./EditableTable.vue?vue&type=template&id=6654a6a3&scoped=true&"
import script from "./EditableTable.vue?vue&type=script&lang=js&"
export * from "./EditableTable.vue?vue&type=script&lang=js&"
import style0 from "./EditableTable.vue?vue&type=style&index=0&id=6654a6a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654a6a3",
  null
  
)

export default component.exports